import {SpecialCategories} from './uploads';
import {defineExpenseOverrides, expenseDataModuleFactory} from '../utils/expense-data';

// noinspection JSUnusedGlobalSymbols
const overrides = defineExpenseOverrides({
   getters: {
      /** The server requires a location of 'XX' for cloud expense data */
      location() {
         return 'XX';
      },
   },
});

export default expenseDataModuleFactory(
   'cloudcomputing',
   SpecialCategories.CLOUDCOMPUTING_DOCS,
   overrides
);
